import React from 'react';
import { defaultLogoParams } from '../../constants';
import { LoomIcon } from '../loom';

/**
 * __Loom Attribution icon__
 *
 * The Loom attribution icon without an accompanying wordmark.
 *
 * - [Examples](https://atlassian.design/components/logo/examples)
 * - [Code](https://atlassian.design/components/logo/code)
 * - [Usage](https://atlassian.design/components/logo/usage)
 */
export var LoomAttributionIcon = function LoomAttributionIcon(_ref) {
  var appearance = _ref.appearance,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loom Attribution' : _ref$label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultLogoParams.size : _ref$size,
    testId = _ref.testId,
    _ref$iconColor = _ref.iconColor,
    iconColor = _ref$iconColor === void 0 ? defaultLogoParams.iconColor : _ref$iconColor,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? defaultLogoParams.textColor : _ref$textColor;
  return /*#__PURE__*/React.createElement(LoomIcon, {
    appearance: appearance,
    label: label,
    size: size,
    testId: testId,
    iconColor: iconColor,
    textColor: textColor
  });
};